import React from 'react'
import Modal, { Header } from 'src/components/theme/Models/Modal'
import Body from './Body'
import { useEeocContext } from '../useEeoc'

interface EditModelProps {
  id: string
}

const EditModel: React.FC<EditModelProps> = (props) => {
  const { id } = props
  const { modals: { send } } = useEeocContext()

  return (
    <Modal
      title='Send EEOC Paperwork'
      isOpen={send.isOpen}
      toggle={send.toggle}
    >
      <Header title='Send EEOC Paperwork' />
      <Body id={id} />
    </Modal>
  )
}

export default EditModel
